module.exports = "<span class=\"status\"\n  role=\"img\"\n  [attr.aria-label]=\"label\"\n  [ngClass]=\"tone\"\n  [title]=\"label\"></span>\n";